import HomeActionType from '../actionTypes/HomeActionType';

const initialState = { listCartItem: [], isOnline: true };

export default (state = initialState, action) => {
  switch (action.type) {
    case HomeActionType.UPDATE_CART_ITEMS:
      return { ...state, listCartItem: action.listCartItem };
    case HomeActionType.UPDATE_POS_DEVICES_CART_ITEMS:
      return { ...state, listPOSDeviceCartItem: action.listPOSDeviceCartItem };
    case HomeActionType.UPDATE_DRAFT_ORDERS:
      return { ...state, draftOrders: action.draftOrders };
    case HomeActionType.UPDATE_NETWORK_STATE:
      return { ...state, isOnline: action.isOnline };
    case HomeActionType.UPDATE_COUNT_NOTIFY:
      return { ...state, countNotify: action.countNotify };
    case HomeActionType.UPDATE_EVENTS:
      return { ...state, events: action.events };
    default:
      return state;
  }
};
